import React, { useContext } from "react";

const TickIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="37"
      height="39"
      viewBox="0 0 37 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="tick-icon"
    >
      <path
        d="M2 9.08333L11.5789 19L28 2"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default TickIcon;
